import { ComponentProps } from '@stitches/react'
import { Link } from 'components/Link'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { BlogPostItemFields } from 'features/Blog/screens/Post'
import { BlogPostMetadata } from 'features/Blog/screens/Post/Post'
import Image from 'next/image'
import { capitalize } from 'utils/capitalize'
import { PostCardContent, PostCardImage, PostCardRoot } from './PostCard.styles'

type PostCardOwnProps = ComponentProps<typeof PostCardRoot>

type PostCardProps = PostCardOwnProps & {
  post: {
    fields: BlogPostItemFields
    metadata: BlogPostMetadata
  }
}

export const PostCard = ({ post, ...rest }: PostCardProps) => {
  return (
    <Link href={`/blog/${post.fields.postUrl}`} passHref>
      <PostCardRoot {...rest}>
        <PostCardImage>
          {post.fields.headerImage?.fields.file && (
            <Image
              src={`https:${post.fields.headerImage.fields.file.url}`}
              alt={post.fields.headerImage.fields.title}
              width="377"
              height="208"
              objectFit="cover"
              objectPosition="top"
            />
          )}
        </PostCardImage>

        <PostCardContent>
          <Text weight="medium" color="primary-500">
            {post.metadata.tags.map((tag) => capitalize(tag.sys.id)).join(' ')}
          </Text>

          <Stack direction="column" className="wrapper">
            <Text
              as="h5"
              size="h5"
              weight="medium"
              css={{
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: 2,
                overflow: 'hidden',
              }}
            >
              {post.fields.postTitle}
            </Text>

            <Text
              css={{
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: 6,
                overflow: 'hidden',
              }}
            >
              {post.fields.postSummary}
            </Text>
          </Stack>
        </PostCardContent>
      </PostCardRoot>
    </Link>
  )
}
